module.exports = __webpack_public_path__ + "static/img/top_bottom_left.e0f1a683.png";